import { createFileRoute } from '@tanstack/react-router'

import { DriverRechargeLayout } from '@/app/layouts'

export const Route = createFileRoute('/_protected/driver-recharge')({
    component: DriverRechargeLayout,
})
